class ByobDiscountCartNote extends HTMLElement {
  constructor() {
    super();

    this.url = window.themeVariables?.byob.url || ''
    this.link = this.querySelector('[data-byob-page-link]')
  }

  connectedCallback() {
    if (this.link) {
      this.link.setAttribute('href', this.url)
    }

    this.hidden = !window.hasByob
  }
}

customElements.define('byob-discount-cart-note', ByobDiscountCartNote);

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('rebuy:cart.ready', async (event) => {
    const items = event.detail.cart.cart.items
    const hasByob = checkForByob(items)
    window.hasByob = hasByob
    updateCartNotice(hasByob)
  });

  document.addEventListener('rebuy:cart.change', async (event) => {
    const items = event.detail.cart.cart.items
    const hasByob = checkForByob(items)
    if (window.hasByob && !hasByob) {
      const showByobPopup = new CustomEvent('show-byob-popup')
      document.dispatchEvent(showByobPopup)
    }
    window.hasByob = hasByob
    updateCartNotice(hasByob)
  });

  function checkForByob(cartItems) {
    if (cartItems.length < 1) { return false }

    const discountCode = window.themeVariables?.byob.discount_code || 'BYOB Discount'
    return cartItems.some((item) => {
      return (
        item.discounts.length &&
        item.discounts.some(discount => discount.title === discountCode)
      )
    })
  }

  function updateCartNotice(hasByob) {
    const cartNotice = document.querySelector('byob-discount-cart-note')
    if (!cartNotice) { return }
    cartNotice.hidden = !hasByob
  }
})